import { render, staticRenderFns } from "./PaginationItemsShow.vue?vue&type=template&id=60ca6be8"
import script from "./PaginationItemsShow.vue?vue&type=script&lang=js"
export * from "./PaginationItemsShow.vue?vue&type=script&lang=js"
import style0 from "./PaginationItemsShow.vue?vue&type=style&index=0&id=60ca6be8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports